<template>
	<div class="wrap">
		<Title :title="detailModel.vacationName"></Title>
		<div class="contract-info">
			<h3>活动费用记账凭证</h3>
			<span>{{entity.addTime}}</span>
		</div>
		<el-table border size="mini" :data="dataList" style="width: 100%">
			<el-table-column prop="vacationNo" label="活动编号">
			</el-table-column>
			<el-table-column prop="startCompayName" label="发布者">
			</el-table-column>
			<el-table-column prop="recruitNum" label="招募人数（个）">
			</el-table-column>
			<el-table-column v-if="isPlatFlag==1" prop="recruitmentFee" label="单价（元）">
			</el-table-column>
			<el-table-column prop="allPrice" label="费用总计（元）">
			</el-table-column>
		</el-table>
		<div class="contract-down">
			<span @click="toDownVoucher">下载记账凭证</span>
			<a :href="entity.serviceContractFileUrl" target="_blank">下载平台服务协议</a>
		</div>
	</div>
</template>

<script>
	import Title from '@/components/titleAdmin'
	import qs from 'qs'
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	import activityDetailModule from '@/modules/adminActivity/detail.js'
	export default {
		name: 'Contract',
		components: {
			Title
		},
		mixins: [
			activityDetailModule
		],
		data() {
			return {
				vacationId: '',
				dataList: [],
				entity: {},
				isPlatFlag: ''
			}
		},
		created() {
			this.vacationId = this.$route.query.id || ''
			this.getDetailData()
		},
		methods: {
			//获取数据
			async getDetailData() {
				let param = {
					id: this.vacationId
				}
				ajaxParam(param)
				const res = await post('admin/vacation/contract', qs.stringify(param))
				console.log(res.data)
				if (res.data.code == 200) {
					this.dataList.push(res.data.entity)
					this.entity = res.data.entity
				}
			},
			toDownVoucher(){
				let url = config.baseUrl + 'admin/word/exportWORD?vacationId='+this.vacationId
				window.location.href =  url
			}
		}
	}
</script>

<style scoped lang="less">
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}

	.contract-info {
		display: flex;
		padding: 10px 0 20px;

		h3 {
			width: 50%;
			font-size: 18px;
			font-weight: bold;
		}
	}

	.contract-down {
		padding-top: 15px;

		a, span {
			margin-right: 20px;
			cursor: pointer;
			color: #2A76CD;
			font-size: 13px;
		}
	}
</style>